import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderheaderService {
  private isdropdownOpen = new BehaviorSubject<any>(true);
  isdropdownOpen$ = this.isdropdownOpen.asObservable();

  constructor() { }

  setvalue(value: boolean) {
    this.isdropdownOpen.next(value)
  }
}
